var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M75 37.594C75 16.8421 58.2 0 37.5 0C16.8 0 0 16.8421 0 37.594C0 55.7895 12.9 70.9398 30 74.4361V48.8722H22.5V37.594H30V28.1955C30 20.9398 35.8875 15.0376 43.125 15.0376H52.5V26.3158H45C42.9375 26.3158 41.25 28.0075 41.25 30.0752V37.594H52.5V48.8722H41.25V75C60.1875 73.1203 75 57.1053 75 37.594Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.c3b93280ace47813453c98ada10e3d54.svg";
export { ForwardRef as ReactComponent };